import type * as LibraryPagesModule from './libraryPages';

export type LibraryPages = typeof LibraryPagesModule;

export const importLibraryPages = (): Promise<LibraryPages> => import('./libraryPages');
